export const ROW_TYPE_CONTINUE_WATCHING_CHANNELS = 'continue watching channels'
export const ROW_TYPE_IMAGES = 'images'
export const ROW_TYPE_FULLSIZE_BANNER = 'fullsize banner'
export const ROW_TYPE_OFFSET_ROW = 'offset row'

